var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.428,
    height: 60.757,
    viewBox: "0 0 144.428 60.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Group",
    d: "M-49,61.108A40.89,40.89,0,0,1-38.953,35.62c6.017-6.678,14-10.4,22.292-10.4a28.04,28.04,0,0,1,2.918.161A47.3,47.3,0,0,1,1.988,7.061,38.349,38.349,0,0,1,23.436.351,38.34,38.34,0,0,1,44.888,7.037a47.282,47.282,0,0,1,15.746,18.3c.812-.071,1.629-.119,2.456-.119,8.3,0,16.275,3.723,22.292,10.4A40.891,40.891,0,0,1,95.428,61.108",
    transform: "translate(49 -0.351)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.cac951f6aa6564311f0034d0d4eb7c8a.svg";
export { ForwardRef as ReactComponent };